Hop.defineModule('signin-mandatory', (root) => {
    function addListener() {
        root.addEventListener('click', showSigninModal);
    }

    function showSigninModal(e) {
        const actuatedElement = e.currentTarget;

        const isConnected = actuatedElement.getAttribute('data-is-connected');
        if (isConnected === 'true') {
            return;
        }

        e.preventDefault();
        e.stopImmediatePropagation();

        Hop.connect.control.showSigninPopup(actuatedElement, false);
    }

    addListener();

    return function destroy() {
        root.removeEventListener('click', showSigninModal);
    };
});
